import { CartCountResponse, ErrorResponse, ServiceResponse } from '@bzbs/react-api-client';
import { create } from 'zustand';
import { useBuzzebeesAppStore } from './buzzebeess-app.store';
import { useLocaleStore } from './locale.store';

export type CartState = {
  count: number;
  isLoading: boolean;
  error: ErrorResponse | null;
};

export type CartActions = {
  fetchCount: () => Promise<ServiceResponse<CartCountResponse>>;
  clear: () => void;
};

export type CartStore = CartState & CartActions;

export const useCartStore = create<CartStore>((set) => {
  return {
    count: 0,
    isLoading: false,
    error: null,

    fetchCount: async () => {
      const bzbsService = useBuzzebeesAppStore.getState().bzbsService;

      if (!bzbsService) {
        return { type: 'client-error', message: 'Service not configured' };
      }

      set({ isLoading: true, error: null });
      const response = await bzbsService.cartApi.cartCount({
        deviceLocale: useLocaleStore.getState().localeId,
      });
      set({ isLoading: false, error: null });

      if (response.type === 'success') {
        set({ count: response.model.cart_count });
      } else {
        set({ error: response });
      }

      return response;
    },

    clear: () => {
      set({
        count: 0,
        isLoading: false,
        error: null,
      });
    },
  };
});
